// assets
import { HomeOutlined, SlidersOutlined, EnvironmentOutlined, CloudUploadOutlined } from '@ant-design/icons';

// icons
const icons = {
  HomeOutlined,
  SlidersOutlined,
  EnvironmentOutlined,
  CloudUploadOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const property = {
  id: 'group-property',
  title: 'Land Information',
  type: 'group',
  children: [
    {
      id: 'property',
      title: 'Property finder',
      type: 'item',
      url: '/propertyform',
      icon: icons.HomeOutlined,
      breadcrumbs: false,
      matchPath: ['/propertyform', '/propertyinfo']
    },
    {
      id: 'valuations',
      title: 'My Valuations',
      type: 'item',
      url: '/myvaluations',
      icon: icons.SlidersOutlined,
      breadcrumbs: false
    },
    {
      id: 'land-information',
      title: 'Planning Zones',
      type: 'item',
      url: '/land-information',
      icon: icons.EnvironmentOutlined,
      breadcrumbs: false
    },
    {
      id: 'transaction-uploads',
      title: 'Transaction Uploads',
      type: 'item',
      url: '/transaction-uploads',
      icon: icons.CloudUploadOutlined,
      breadcrumbs: false
    }
  ]
};

export default property;
